<template>
  <v-form ref="form">
    <!-- Nom -->
    <v-text-field
      v-model="client.name"
      :rules="nameErrors"
      :counter="150"
      label="Nom du client / Raison sociale du client *"
      required
    ></v-text-field>

    <!-- Email -->
    <v-text-field
      v-model="client.email"
      :rules="emailErrors"
      label="E-mail"
      required
    ></v-text-field>

    <!-- Commentaire -->
    <v-textarea v-model="client.comment" label="Commentaire client"/>

    <ClientUserRightTable
      v-model="client"
      @addClientUserRight="addClientUserRight"
      @removeClientUserRight="removeClientUserRight"
    ></ClientUserRightTable>

    

    <v-btn class="float-right" color="primary" @click="submit">
      Valider
    </v-btn>
  </v-form>
</template>
<script>

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ClientUserRightTable from "@/components/admin/client/forms/tabs/clientUserRightTable.vue";
import Swal from "sweetalert2";

export default {
  name: "formClient",
  data() {
    return {
      valid: false,
      nameErrors: [
        (v) => !!v || "Le nom ou la raison sociale est obligatoire.",
        (v) => v.length >= 2 || "Le nom doit être supérieur à 2 caractères",
      ],
      emailErrors: [
        v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || "L'adresse e-mail n'est pas valide",
      ],
      clients: [],
    };
  },
  components:{
    ClientUserRightTable,
  },
  model: {
    prop: "client",
    event: "input",
  },
  props: {
    client: Object,
    userRight: Object,
  },

  methods: {
    submit(e) {
      e.preventDefault();
      if (this.$refs.form.validate()) {
        this.$emit("submit");
      }   
    },
    
    addClientUserRight(userRight) {
      const exists = this.client.userRights.some((ur) => ur.id === userRight.id);

      if (exists) {
        Swal.fire({
          title: "",
          text: "Ce droit utilisateur est déjà inclus dans la liste.",
          confirmButtonClass: "btn btn-secondary",
        });
      } else {
        this.client.userRights.push(userRight);
      }
    },
    removeClientUserRight(userRight) {
      this.client.userRights = this.client.userRights.filter((u) => u.id !== userRight.id);
    },
  },
  
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Administration", route: "gestionClients"},
      { title: "Gestion des clients" },
    ]);
  },
};
</script>
